import update from 'transmute/update';
import { objectEntries } from '../../objectUtils/objectEntries';
import { useMemo } from 'react';
import { useRecentlyUsedPropertiesValue } from './useRecentlyUsedPropertiesValue';
const calculateRecentlyUsedPropertyNames = value => {
  const usageCountsByPropertyName = value.reduce((propertyCounts, {
    name
  }) => update(name, (count = 0) => count + 1, propertyCounts), {});
  return objectEntries(usageCountsByPropertyName).sort(([__aName, aCount], [__bName, bCount]) => bCount - aCount).map(([name]) => name);
};
export const useRecentlyUsedPropertyNames = () => {
  const value = useRecentlyUsedPropertiesValue();
  return useMemo(() => calculateRecentlyUsedPropertyNames(value), [value]);
};